import * as Types from '../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
import {
  UnifiedPlayerNextFragment,
  UnifiedPlayerParentalGuidanceFragment,
  UnifiedPlayerEntityFragment,
  UnifiedPlayerPlaybackFragment,
  UnifiedPlayerVodTrackingFragment,
  UnifiedPlayerLiveTrackingFragment,
  UnifiedPlayerTrackingFragment,
} from '../../sharedFragments/__generated__/fragments';
export type PlayChromecastContentPlaybackQueryVariables = Types.Exact<{
  guid: Types.Scalars['String']['input'];
  deviceId: Types.Scalars['String']['input'];
  deviceDescription: Types.Scalars['String']['input'];
  format: Array<Types.InputMaybe<Types.Format>> | Types.InputMaybe<Types.Format>;
  drm: Array<Types.InputMaybe<Types.Drm>> | Types.InputMaybe<Types.Drm>;
  lar?: Types.InputMaybe<Array<Types.InputMaybe<Types.Lar>> | Types.InputMaybe<Types.Lar>>;
  codec?: Types.InputMaybe<Array<Types.InputMaybe<Types.Codec>> | Types.InputMaybe<Types.Codec>>;
  resolution?: Types.InputMaybe<
    | Array<Types.InputMaybe<Types.Scalars['String']['input']>>
    | Types.InputMaybe<Types.Scalars['String']['input']>
  >;
  dynamicRange?: Types.InputMaybe<
    Array<Types.InputMaybe<Types.DynamicRange>> | Types.InputMaybe<Types.DynamicRange>
  >;
  maxBPS?: Types.InputMaybe<Array<Types.InputMaybe<Types.MaxBps>> | Types.InputMaybe<Types.MaxBps>>;
  nielsenTrackingVersion?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type PlayChromecastContentPlaybackQuery = {
  entity:
    | {
        __typename: 'Broadcast';
        presentationSubtitle: string | null;
        free: boolean | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        epgEntries: {
          __typename: 'EpgList';
          nodes: Array<{
            __typename: 'Epg';
            title: string | null;
            live: boolean | null;
            subPrograms: Array<{ __typename: 'Epg'; live: boolean | null } | null> | null;
          } | null> | null;
        } | null;
        presentationArt: { __typename: 'Art'; url: string | null } | null;
        scalableLogo: { __typename: 'ScalableLogo'; regular: string };
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
      }
    | {
        __typename: 'Episode';
        seriesTitle: string | null;
        seriesGuid: string | null;
        seasonNumber: number | null;
        episodeNumber: number | null;
        presentationSubtitle: string | null;
        duration: number | null;
        free: boolean | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
        contentProvider: {
          __typename: 'ContentProvider';
          guid: string;
          title: string | null;
          broadcast: {
            __typename: 'Broadcast';
            presentationTitle: string | null;
            broadcastName: string | null;
          } | null;
        } | null;
        next: {
          __typename: 'Episode';
          type: Types.EntityType | null;
          presentationSubtitle: string | null;
          guid: string;
          episodeNumber: number | null;
          seasonNumber: number | null;
          presentationTitle: string | null;
          presentationArt: { __typename: 'Art'; url: string | null } | null;
          teaser: {
            __typename: 'EntityTeaser';
            label: {
              __typename: 'EntityLabel';
              text: string | null;
              backgroundColor: string | null;
            } | null;
          } | null;
        } | null;
        series: {
          __typename: 'Series';
          presentationTitle: string | null;
          presentationArt: { __typename: 'Art'; url: string | null } | null;
        } | null;
        parentalGuidance: {
          __typename: 'ParentalGuidance';
          parentalRatingImageInverted: string | null;
          voiceoverDescription: string | null;
        } | null;
        genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
      }
    | {
        __typename: 'Event';
        title: string | null;
        presentationSubtitle: string | null;
        liveEvent: boolean | null;
        guid: string;
        type: Types.EntityType | null;
        presentationTitle: string | null;
        subtitle: string | null;
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
        referred: {
          __typename: 'ReferredType';
          start: number | null;
          stop: number | null;
          entity:
            | {
                __typename: 'Broadcast';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'Episode';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'Event';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'Movie';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'Program';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'Series';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'SportingEvent';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | {
                __typename: 'Station';
                tags: Array<string | null> | null;
                guid: string;
                references: { __typename: 'References'; guid: string; destination: string };
              }
            | null;
        } | null;
        presentationArt: { __typename: 'Art'; url: string | null } | null;
        genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        references: { __typename: 'References'; web: string };
      }
    | {
        __typename: 'Movie';
        presentationSubtitle: string | null;
        free: boolean | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
        art: {
          __typename: 'ArtList';
          nodes: Array<{
            __typename: 'Art';
            type: string | null;
            url: string | null;
            ratio: Types.ArtRatioType | null;
          } | null> | null;
        };
        parentalGuidance: {
          __typename: 'ParentalGuidance';
          parentalRatingImageInverted: string | null;
          voiceoverDescription: string | null;
        } | null;
        contentProvider: {
          __typename: 'ContentProvider';
          guid: string;
          title: string | null;
        } | null;
        genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
      }
    | {
        __typename: 'Program';
        presentationSubtitle: string | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
        presentationArt: { __typename: 'Art'; url: string | null } | null;
        parentalGuidance: {
          __typename: 'ParentalGuidance';
          parentalRatingImageInverted: string | null;
          voiceoverDescription: string | null;
        } | null;
        genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
      }
    | {
        __typename: 'Series';
        presentationSubtitle: string | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
      }
    | {
        __typename: 'SportingEvent';
        presentationSubtitle: string | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
      }
    | {
        __typename: 'Station';
        presentationSubtitle: string | null;
        guid: string;
        type: Types.EntityType | null;
        title: string | null;
        presentationTitle: string | null;
        subtitle: string | null;
        referred: {
          __typename: 'ReferredType';
          entity:
            | { __typename: 'Broadcast'; guid: string }
            | { __typename: 'Episode'; guid: string }
            | { __typename: 'Event'; guid: string }
            | { __typename: 'Movie'; guid: string }
            | { __typename: 'Program'; guid: string }
            | { __typename: 'Series'; guid: string }
            | { __typename: 'SportingEvent'; guid: string }
            | { __typename: 'Station'; guid: string }
            | null;
        } | null;
        references: { __typename: 'References'; web: string };
        teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
      }
    | null;
  tracking:
    | {
        __typename: 'LiveTracking';
        adobe: {
          __typename: 'DetailedAdobeBlockList';
          nodes: Array<{
            __typename: 'DetailedAdobeBlock';
            program: {
              __typename: 'DetailedAdobe';
              id: string | null;
              title: string | null;
              duration: number | null;
              broadcast: string | null;
              type: string | null;
              ad: boolean | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean | null;
            } | null;
            prerolls: {
              __typename: 'DetailedAdobeList';
              nodes: Array<{
                __typename: 'DetailedAdobe';
                id: string | null;
                title: string | null;
                duration: number | null;
                broadcast: string | null;
                type: string | null;
                ad: boolean | null;
                start: number | null;
                stop: number | null;
              } | null> | null;
            } | null;
          } | null> | null;
          active: {
            __typename: 'DetailedAdobeBlock';
            program: {
              __typename: 'DetailedAdobe';
              id: string | null;
              title: string | null;
              duration: number | null;
              broadcast: string | null;
              type: string | null;
              ad: boolean | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean | null;
            } | null;
          } | null;
        } | null;
        nielsen: {
          __typename: 'DetailedNielsenList';
          nodes: Array<{
            __typename: 'DetailedNielsen';
            trackingObject: string | null;
            ad: boolean | null;
            start: number | null;
            stop: number | null;
          } | null> | null;
          active: {
            __typename: 'DetailedNielsen';
            trackingObject: string | null;
            ad: boolean | null;
            start: number | null;
            stop: number | null;
          } | null;
        } | null;
      }
    | {
        __typename: 'VodTracking';
        adobe: {
          __typename: 'Adobe';
          id: string;
          programTitle: string;
          title: string;
          seriesTitle: string | null;
          type: string;
          labels: string | null;
          category: string | null;
        } | null;
        nielsen: { __typename: 'Nielsen'; trackingObject: string | null } | null;
      }
    | null;
  media: {
    __typename: 'Media';
    mediaType: string | null;
    duration: number | null;
    streams: Array<{
      __typename: 'Stream';
      format: Types.Format | null;
      url: string | null;
      capabilities: Array<{
        __typename: 'Capability';
        capabilityType: Types.CapabilityType | null;
        values: Array<string>;
      } | null>;
      drmLicense: { __typename: 'DrmLicense'; drm: Types.Drm; url: string; token: string } | null;
      ad: {
        __typename: 'Ad';
        vendor: Types.AdVendor | null;
        url: string | null;
        ppid: string | null;
        segmentation: string | null;
      } | null;
    } | null>;
    trickmode: {
      __typename: 'TrickMode';
      webVideoTextTracksFormatUrl: string | null;
      tiledThumbnailsUrl: string | null;
    } | null;
    subtitles: Array<{ __typename: 'Subtitle'; useAsDefault: boolean | null } | null>;
    concurrency: {
      __typename: 'Concurrency';
      updateInterval: number | null;
      httpMethod: string | null;
      url: string | null;
      body: {
        __typename: 'ConcurrencyBody';
        token: string | null;
        progress: number | null;
        guid: string | null;
        userAction: string | null;
        concurrencyAction: string | null;
      } | null;
    } | null;
  } | null;
};

export type EntityFragmentBroadcast = {
  __typename: 'Broadcast';
  presentationSubtitle: string | null;
  free: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  epgEntries: {
    __typename: 'EpgList';
    nodes: Array<{
      __typename: 'Epg';
      title: string | null;
      live: boolean | null;
      subPrograms: Array<{ __typename: 'Epg'; live: boolean | null } | null> | null;
    } | null> | null;
  } | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  scalableLogo: { __typename: 'ScalableLogo'; regular: string };
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type EntityFragmentEpisode = {
  __typename: 'Episode';
  seriesTitle: string | null;
  seriesGuid: string | null;
  seasonNumber: number | null;
  episodeNumber: number | null;
  presentationSubtitle: string | null;
  duration: number | null;
  free: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
  contentProvider: {
    __typename: 'ContentProvider';
    guid: string;
    title: string | null;
    broadcast: {
      __typename: 'Broadcast';
      presentationTitle: string | null;
      broadcastName: string | null;
    } | null;
  } | null;
  next: {
    __typename: 'Episode';
    type: Types.EntityType | null;
    presentationSubtitle: string | null;
    guid: string;
    episodeNumber: number | null;
    seasonNumber: number | null;
    presentationTitle: string | null;
    presentationArt: { __typename: 'Art'; url: string | null } | null;
    teaser: {
      __typename: 'EntityTeaser';
      label: {
        __typename: 'EntityLabel';
        text: string | null;
        backgroundColor: string | null;
      } | null;
    } | null;
  } | null;
  series: {
    __typename: 'Series';
    presentationTitle: string | null;
    presentationArt: { __typename: 'Art'; url: string | null } | null;
  } | null;
  parentalGuidance: {
    __typename: 'ParentalGuidance';
    parentalRatingImageInverted: string | null;
    voiceoverDescription: string | null;
  } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
};

export type EntityFragmentEvent = {
  __typename: 'Event';
  title: string | null;
  presentationSubtitle: string | null;
  liveEvent: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  presentationTitle: string | null;
  subtitle: string | null;
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
  referred: {
    __typename: 'ReferredType';
    start: number | null;
    stop: number | null;
    entity:
      | {
          __typename: 'Broadcast';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'Episode';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'Event';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'Movie';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'Program';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'Series';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'SportingEvent';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | {
          __typename: 'Station';
          tags: Array<string | null> | null;
          guid: string;
          references: { __typename: 'References'; guid: string; destination: string };
        }
      | null;
  } | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  references: { __typename: 'References'; web: string };
};

export type EntityFragmentMovie = {
  __typename: 'Movie';
  presentationSubtitle: string | null;
  free: boolean | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
  art: {
    __typename: 'ArtList';
    nodes: Array<{
      __typename: 'Art';
      type: string | null;
      url: string | null;
      ratio: Types.ArtRatioType | null;
    } | null> | null;
  };
  parentalGuidance: {
    __typename: 'ParentalGuidance';
    parentalRatingImageInverted: string | null;
    voiceoverDescription: string | null;
  } | null;
  contentProvider: { __typename: 'ContentProvider'; guid: string; title: string | null } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
};

export type EntityFragmentProgram = {
  __typename: 'Program';
  presentationSubtitle: string | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
  presentationArt: { __typename: 'Art'; url: string | null } | null;
  parentalGuidance: {
    __typename: 'ParentalGuidance';
    parentalRatingImageInverted: string | null;
    voiceoverDescription: string | null;
  } | null;
  genres: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  categories: { __typename: 'StringList'; nodes: Array<string | null> | null } | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
};

export type EntityFragmentSeries = {
  __typename: 'Series';
  presentationSubtitle: string | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type EntityFragmentSportingEvent = {
  __typename: 'SportingEvent';
  presentationSubtitle: string | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type EntityFragmentStation = {
  __typename: 'Station';
  presentationSubtitle: string | null;
  guid: string;
  type: Types.EntityType | null;
  title: string | null;
  presentationTitle: string | null;
  subtitle: string | null;
  referred: {
    __typename: 'ReferredType';
    entity:
      | { __typename: 'Broadcast'; guid: string }
      | { __typename: 'Episode'; guid: string }
      | { __typename: 'Event'; guid: string }
      | { __typename: 'Movie'; guid: string }
      | { __typename: 'Program'; guid: string }
      | { __typename: 'Series'; guid: string }
      | { __typename: 'SportingEvent'; guid: string }
      | { __typename: 'Station'; guid: string }
      | null;
  } | null;
  references: { __typename: 'References'; web: string };
  teaser: { __typename: 'EntityTeaser'; watermark: string | null } | null;
};

export type EntityFragment =
  | EntityFragmentBroadcast
  | EntityFragmentEpisode
  | EntityFragmentEvent
  | EntityFragmentMovie
  | EntityFragmentProgram
  | EntityFragmentSeries
  | EntityFragmentSportingEvent
  | EntityFragmentStation;

export const EntityFragment = gql`
  fragment entityFragment on Entity {
    ...UnifiedPlayerEntityFragment
    presentationSubtitle
    ... on Broadcast {
      epgEntries {
        nodes {
          title
        }
      }
    }
    ... on Movie {
      teaser {
        watermark
      }
    }
    ... on Program {
      teaser {
        watermark
      }
    }
    ... on Episode {
      teaser {
        watermark
      }
      contentProvider {
        broadcast {
          presentationTitle
        }
      }
      seriesTitle
      seriesGuid
      seasonNumber
      episodeNumber
      next {
        type
        presentationSubtitle
      }
    }
    ... on Event {
      teaser {
        watermark
      }
      title
      referred {
        entity {
          references {
            destination: web
            guid
          }
          tags
        }
      }
    }
  }
`;
export const PlayChromecastContentPlayback = gql`
  query play_chromecast_content_Playback(
    $guid: String!
    $deviceId: String!
    $deviceDescription: String!
    $format: [Format]!
    $drm: [Drm]!
    $lar: [Lar]
    $codec: [Codec]
    $resolution: [String]
    $dynamicRange: [DynamicRange]
    $maxBPS: [MaxBPS]
    $nielsenTrackingVersion: String
  ) {
    entity(guid: $guid) {
      ...entityFragment
    }
    tracking(guid: $guid, nielsenVersion: $nielsenTrackingVersion) {
      ...UnifiedPlayerTrackingFragment
    }
    media(
      guid: $guid
      deviceId: $deviceId
      deviceDescription: $deviceDescription
      capabilities: {
        format: $format
        drm: $drm
        lar: $lar
        codec: $codec
        resolution: $resolution
        dynamicRange: $dynamicRange
        maxBPS: $maxBPS
      }
      download: false
    ) {
      ...UnifiedPlayerPlaybackFragment
    }
  }
  ${EntityFragment}
  ${UnifiedPlayerEntityFragment}
  ${UnifiedPlayerParentalGuidanceFragment}
  ${UnifiedPlayerNextFragment}
  ${UnifiedPlayerTrackingFragment}
  ${UnifiedPlayerLiveTrackingFragment}
  ${UnifiedPlayerVodTrackingFragment}
  ${UnifiedPlayerPlaybackFragment}
`;
